// ═══════════════════════════════════════════════════════════════════════════════
// FIREBASE SETUP
// ═══════════════════════════════════════════════════════════════════════════════
// 1. Go to https://console.firebase.google.com → Create a project (free).
// 2. Inside the project: Build → Firestore Database → Create database (start in
//    "production mode" is fine — we set rules below).
// 3. Build → Authentication → Get started → Sign-in method → enable
//    "Email/Password".
// 4. Authentication → Users → Add user, once per person who should log in
//    (email format doesn't matter, e.g. khan4pihouse@espakshop.local).
// 5. Project settings (gear icon) → General → scroll to "Your apps" → Add app
//    → Web (</>) → copy the firebaseConfig object it gives you and paste the
//    values below.
// ═══════════════════════════════════════════════════════════════════════════════

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA9WFrihItJDDcRgLGo3YYCoHAxeL1fY-E",
  authDomain: "shop-manager-a27b0.firebaseapp.com",
  projectId: "shop-manager-a27b0",
  storageBucket: "shop-manager-a27b0.firebasestorage.app",
  messagingSenderId: "160230573524",
  appId: "1:160230573524:web:d059a4c6da84618742c241",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
